<template>
  <div>
    <v-card class="elevation-3 mb-6" id="exceltable">
      <v-card-text class="pa-0">
        <v-simple-table
          class="v-table-color"
          fixed-header
          height="70vh"
          v-if="cycletypeReadview === 'Proforma'"
        >
          <thead>
            <tr>
              <th class="align-center text-left">
                Navigation
                <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on" @click="toggleExpandAll" class="ml-2" data-testid="ru-read-table-view__proforma-expand-collapse-all-btn">
                      {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                    </v-icon>
                  </template>
                  <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
                </v-tooltip>
              </th>
              <th class="text-left">
                {{ $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') }}
              </th>
              <th class="text-left">Description</th>
              <th class="text-left" :style="`background-color: #bfffbf !important`">
                {{
                  cycletype === 'Forecast'
                    ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                    : $nova.labelsName('cycle_page', 'actual_label', 'Actual')
                }}
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.a} !important`">
                {{
                  cycletype === 'Forecast'
                    ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                    : $nova.labelsName('cycle_page', 'actual_label', 'Actual')
                }}
                Vs
                {{ $nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') }}
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.a} !important`">
                {{ commentaryLocalKeyLabel }} Commentary
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.a} !important`">
                {{ commentaryRegionalKeyLabel }} Commentary
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in pagedItems"
              :key="item._id"
              :style="rowStyle(item)"
              class="tree-table"
              v-intersect.quiet="(entries) => entries[0]?.isIntersecting && handleIntersect(item.__index)"
            >
              <template v-if="item.__code === 'NA'">
                <td @click="toggleExpand(item)">
                  <div class="tree-label d-flex align-center" :style="paddingStyle(item)">
                    <div class="node-container">
                      <span class="node-label" :class="'childlevele-' + item.level"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(item) && !isFilterSet" class="expand-icon">
                        <v-icon small data-testid="ru-read-table-view__proforma-na-expand-icon">
                          {{ isExpanded(item) ? 'mdi-minus-box' : 'mdi-plus-box' }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td>NA</td>
                <td class="description-cell" colspan="12">
                  <span>{{ item.glcode_detail.name }}</span>
                </td>
              </template>
              <template v-else>
                <td @click="toggleExpand(item)">
                  <div class="tree-label d-flex align-center" :style="paddingStyle(item)">
                    <div class="node-container-read">
                      <span class="node-label" :class="'childlevele-' + item.level"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(item) && !isFilterSet" class="expand-icon">
                        <v-icon small data-testid="ru-read-table-view__proforma-gl-expand-icon">
                          {{ isExpanded(item) ? 'mdi-minus-box' : 'mdi-plus-box' }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td>{{ item.glcode_detail.code }}</td>
                <td class="description-cell">
                  <span>{{ item.glcode_detail.name }}</span>
                </td>
                <td :style="`background-color: rgba(0,250,0,0.05) !important`">
                  {{ $nova.formatCurrency(item.amount1.toFixed(1), '', false, true) }}
                </td>
                <td :style="`background-color: ${tablecolors.body.a} !important`">
                  <div class="d-flex flex-column pa-2">
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{ $nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma') }}:
                      </span>
                      <span>{{ $nova.formatCurrency(item.amount2.toFixed(1), '', false, true) }}</span>
                    </div>
                    <v-divider class="my-1"></v-divider>
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{
                          $nova.labelsName('cycle_page', 'commentary_variance_amount_label', 'Variance Amt')
                        }}
                      </span>
                      <span :class="varianceClass(item.varianceamount1)">
                        {{ $nova.formatCurrency(item.varianceamount1.toFixed(1), '', false, true) }}
                      </span>
                    </div>
                    <v-divider class="my-1"></v-divider>
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{ $nova.labelsName('cycle_page', 'commentary_variance_label', 'Variance') }}%:
                      </span>
                      <span :class="varianceClass(item.varianceamount1)">
                        {{
                          $nova.formatCurrency(item.variancepercent1.toFixed(1), '', false, true)
                        }}{{ item.variancepercent1 !== 0 ? '%' : '' }}
                      </span>
                    </div>
                  </div>
                </td>
                <td :style="`background-color: ${tablecolors.body.b} !important; width: 500px;`">
                  <v-card flat class="pa-4" v-if="isActualJVCommentaryValidForLocal(item)">
                    <div class="text-caption">
                      <v-chip x-small density="comfortable">JV:</v-chip>
                      {{ formatObjectEntries(item.jv_commentary1) }}
                    </div>
                  </v-card>
                  <v-card
                    flat
                    class="pa-4"
                    v-else-if="item.commentary1 && item.commentary1 !== '' && !item.ignorecommentary"
                  >
                    <div class="text-caption" v-html="localCommentary1Count(item)"></div>
                    <v-tooltip
                      top
                      max-width="500px"
                      v-if="commentaryChart(item.commentary1, item.approvereason)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small text color="primary" class="ml-1" v-bind="attrs" v-on="on" data-testid="ru-read-table-view__proforma-local-seemore-btn">
                          ...See More
                        </v-btn>
                      </template>
                      <v-row>
                        <v-col cols="12">
                          <strong>Comment:</strong>
                          <div class="ml-5">{{ item.commentary1 }}</div>
                        </v-col>
                        <v-col cols="12" class="mt-3" v-if="item.approvereason">
                          <strong>
                            {{
                              $nova.labelsName(
                                'reporting_units_bulk_file',
                                'local_regional_reason',
                                'Regional Approval Reason'
                              )
                            }}:
                          </strong>
                          <div class="ml-5">{{ item.approvereason }}</div>
                        </v-col>
                      </v-row>
                    </v-tooltip>
                  </v-card>
                </td>
                <td :style="`background-color: ${tablecolors.body.b} !important; width: 500px;`">
                  <template v-if="isActualJVCommentaryValidForRegional(item)">
                    <v-card flat class="pa-4">
                      <div class="text-caption">
                        <v-chip x-small density="comfortable">JV:</v-chip>
                        {{ formatObjectEntries(item.jv_commentary1) }}
                      </div>
                    </v-card>
                  </template>
                  <template v-else-if="item.regionalcommentary2">
                    <v-card flat class="pa-4">
                      <div class="text-caption" v-html="regionalCommentary1Count(item)"></div>
                      <v-tooltip
                        top
                        max-width="500px"
                        v-if="commentaryChart(item.regionalcommentary2, item.regionalapprovereason)"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn x-small text color="primary" class="ml-1" v-bind="attrs" v-on="on" data-testid="ru-read-table-view__proforma-regional-seemore-btn">
                            ...See More
                          </v-btn>
                        </template>
                        <v-row>
                          <v-col cols="12">
                            <strong>Comment:</strong>
                            <div class="ml-5">{{ item.regionalcommentary2 }}</div>
                          </v-col>
                          <v-col cols="12" class="mt-3" v-if="item.regionalapprovereason">
                            <strong>
                              {{
                                $nova.labelsName(
                                  'reporting_units_bulk_file',
                                  'local_regional_reason',
                                  'Regional Approval Reason'
                                )
                              }}:
                            </strong>
                            <div class="ml-5">{{ item.regionalapprovereason }}</div>
                          </v-col>
                        </v-row>
                      </v-tooltip>
                    </v-card>
                  </template>
                </td>
              </template>
            </tr>
          </tbody>
        </v-simple-table>

        <v-simple-table
          class="v-table-color"
          fixed-header
          height="70vh"
          v-else
        >
          <thead>
            <tr>
              <th class="align-center text-left">
                Navigation
                <v-tooltip bottom content-class="tooltip-bottom">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on" @click="toggleExpandAll" class="ml-2" data-testid="ru-read-table-view__forecast-expand-collapse-all-btn">
                      {{ isAllExpanded ? 'mdi-collapse-all' : 'mdi-expand-all' }}
                    </v-icon>
                  </template>
                  <span>{{ isAllExpanded ? 'Collapse All' : 'Expand All' }}</span>
                </v-tooltip>
              </th>
              <th class="text-left">
                {{ $nova.labelsName('cycle_page', 'commentary_gl_code_label', 'GL Code') }}
              </th>
              <th class="text-left">Description</th>
              <th class="text-left" :style="`background-color: #bfffbf !important`">
                {{
                  cycletype === 'Forecast'
                    ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                    : $nova.labelsName('cycle_page', 'actual_label', 'Actual')
                }}
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.b} !important`">
                {{
                  cycletype === 'Forecast'
                    ? $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                    : $nova.labelsName('cycle_page', 'actual_label', 'Actual')
                }}
                Vs
                {{
                  cycletype === 'Forecast'
                    ? 'Previous ' + $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                    : $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                }}
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.b} !important`">
                {{ commentaryLocalKeyLabel }} Commentary
              </th>
              <th class="text-center" :style="`background-color: ${tablecolors.heading.b} !important`">
                {{ commentaryRegionalKeyLabel }} Commentary
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in pagedItems"
              :key="item._id"
              :style="rowStyle(item)"
              class="tree-table"
              v-intersect.quiet="(entries) => entries[0]?.isIntersecting && handleIntersect(item.__index)"
            >
              <template v-if="item.__code === 'NA'">
                <td @click="toggleExpand(item)">
                  <div class="tree-label d-flex align-center" :style="paddingStyle(item)">
                    <div class="node-container">
                      <span class="node-label" :class="'childlevele-' + item.level"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(item) && !isFilterSet" class="expand-icon">
                        <v-icon small data-testid="ru-read-table-view__forecast-na-expand-icon">
                          {{ isExpanded(item) ? 'mdi-minus-box' : 'mdi-plus-box' }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td>NA</td>
                <td class="description-cell" colspan="12">
                  <span>{{ item.glcode_detail.name }}</span>
                </td>
              </template>
              <template v-else>
                <td @click="toggleExpand(item)">
                  <div class="tree-label d-flex align-center" :style="paddingStyle(item)">
                    <div class="node-container-read">
                      <span class="node-label" :class="'childlevele-' + item.level"></span>
                    </div>
                    <div>
                      <span v-if="hasChildren(item) && !isFilterSet" class="expand-icon">
                        <v-icon small data-testid="ru-read-table-view__forecast-gl-expand-icon">
                          {{ isExpanded(item) ? 'mdi-minus-box' : 'mdi-plus-box' }}
                        </v-icon>
                      </span>
                      <span v-else class="no-children-spacer"></span>
                    </div>
                  </div>
                </td>
                <td>{{ item.glcode_detail.code }}</td>
                <td class="description-cell">
                  <span>{{ item.glcode_detail.name }}</span>
                </td>
                <td :style="`background-color: rgba(0,250,0,0.05) !important`">
                  {{ $nova.formatCurrency(item.amount1.toFixed(1), '', false, true) }}
                </td>
                <td :style="`background-color: ${tablecolors.body.b} !important`">
                  <div class="d-flex flex-column pa-2">
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{
                          cycletype === 'Forecast'
                            ? 'Previous Forecast'
                            : $nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast')
                        }}:
                      </span>
                      <span>{{ $nova.formatCurrency(item.amount3.toFixed(1), '', false, true) }}</span>
                    </div>
                    <v-divider class="my-1"></v-divider>
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{
                          $nova.labelsName('cycle_page', 'commentary_variance_amount_label', 'Variance Amt')
                        }}:
                      </span>
                      <span :class="varianceClass(item.varianceamount2)">
                        {{ $nova.formatCurrency(item.varianceamount2.toFixed(1), '', false, true) }}
                      </span>
                    </div>
                    <v-divider class="my-1"></v-divider>
                    <div class="d-flex justify-space-between">
                      <span class="font-weight-medium">
                        {{
                          $nova.labelsName('cycle_page', 'commentary_variance_label', 'Variance')
                        }}%:
                      </span>
                      <span :class="varianceClass(item.varianceamount2)">
                        {{
                          $nova.formatCurrency(item.variancepercent2.toFixed(1), '', false, true)
                        }}{{ item.variancepercent2 !== 0 ? '%' : '' }}
                      </span>
                    </div>
                  </div>
                </td>
                <td :style="`background-color: ${tablecolors.body.b} !important; width: 500px;`">
                  <v-card flat class="pa-4" v-if="isForecastJVCommentaryValidForLocal(item)">
                    <div class="text-caption">
                      <v-chip x-small density="comfortable">JV:</v-chip>
                      {{ formatObjectEntries(item.jv_commentary2) }}
                    </div>
                  </v-card>
                  <v-card
                    flat
                    class="pa-4"
                    v-else-if="item.commentary2 && item.commentary2 !== '' && !item.ignorecommentary"
                  >
                    <div class="text-caption" v-html="localCommentary2Count(item)"></div>
                    <v-tooltip
                      top
                      max-width="500px"
                      v-if="commentaryChart(item.commentary2, item.approvereason)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small text color="primary" class="ml-1" v-bind="attrs" v-on="on" data-testid="ru-read-table-view__forecast-local-seemore-btn">
                          ...See More
                        </v-btn>
                      </template>
                      <v-row>
                        <v-col cols="12">
                          <strong>Comment:</strong>
                          <div class="ml-5">{{ item.commentary2 }}</div>
                        </v-col>
                        <v-col cols="12" class="mt-3" v-if="item.approvereason">
                          <strong>
                            {{
                              $nova.labelsName(
                                'reporting_units_bulk_file',
                                'local_regional_reason',
                                'Regional Approval Reason'
                              )
                            }}:
                          </strong>
                          <div class="ml-5">{{ item.approvereason }}</div>
                        </v-col>
                      </v-row>
                    </v-tooltip>
                  </v-card>
                </td>
                <td :style="`background-color: ${tablecolors.body.b} !important; width: 500px;`">
                  <v-card flat class="pa-4" v-if="isForecastJVCommentaryValidForRegional(item)">
                    <div class="text-caption">
                      <v-chip x-small density="comfortable">JV:</v-chip>
                      {{ formatObjectEntries(item.jv_commentary2) }}
                    </div>
                  </v-card>
                  <v-card
                    flat
                    class="pa-4"
                    v-else-if="item.regionalcommentary2 && item.regionalcommentary2 !== '' && !item.ignorecommentary"
                  >
                    <div class="text-caption" v-html="regionalCommentary2Count(item)"></div>
                    <v-tooltip
                      top
                      max-width="500px"
                      v-if="commentaryChart(item.regionalcommentary2, item.regionalapprovereason)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn x-small text color="primary" class="ml-1" v-bind="attrs" v-on="on" data-testid="ru-read-table-view__forecast-regional-seemore-btn">
                          ...See More
                        </v-btn>
                      </template>
                      <v-row>
                        <v-col cols="12">
                          <strong>Comment:</strong>
                          <div class="ml-5">{{ item.regionalcommentary2 }}</div>
                        </v-col>
                        <v-col cols="12" class="mt-3" v-if="item.regionalapprovereason">
                          <strong>
                            {{
                              $nova.labelsName(
                                'reporting_units_bulk_file',
                                'local_regional_reason',
                                'Regional Approval Reason'
                              )
                            }}:
                          </strong>
                          <div class="ml-5">{{ item.regionalapprovereason }}</div>
                        </v-col>
                      </v-row>
                    </v-tooltip>
                  </v-card>
                </td>
              </template>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'RUReadTableView',
  props: {
    cycletypeReadview: { type: String, default: 'Proforma' },
    tablecolors: { type: Object, default: () => ({ heading: {}, body: {} }) },
    cycletype: { type: String, default: '' },
    commentaryLocalKeyLabel: { type: String, default: '' },
    commentaryRegionalKeyLabel: { type: String, default: '' },
    pagedItems: { type: Array, default: () => [] },
    isFilterSet: { type: Boolean, default: false },
    isAllExpanded: { type: Boolean, default: false },
    toggleExpandAllFn: { type: Function, required: true },
    toggleExpandFn: { type: Function, required: true },
    hasChildrenFn: { type: Function, required: true },
    isExpandedFn: { type: Function, required: true },
    handleIntersectFn: { type: Function, required: true },
    localCommentary1CountFn: { type: Function, required: true },
    localCommentary2CountFn: { type: Function, required: true },
    regionalCommentary1CountFn: { type: Function, required: true },
    regionalCommentary2CountFn: { type: Function, required: true },
    commentaryChartFn: { type: Function, required: true },
    isActualJVCommentaryValidForLocalFn: { type: Function, required: true },
    isActualJVCommentaryValidForRegionalFn: { type: Function, required: true },
    isForecastJVCommentaryValidForLocalFn: { type: Function, required: true },
    isForecastJVCommentaryValidForRegionalFn: { type: Function, required: true },
  },
  methods: {
    toggleExpandAll() {
      this.toggleExpandAllFn();
    },
    toggleExpand(item) {
      this.toggleExpandFn(item);
    },
    hasChildren(item) {
      return this.hasChildrenFn(item);
    },
    isExpanded(item) {
      return this.isExpandedFn(item);
    },
    handleIntersect(index) {
      this.handleIntersectFn(index);
    },
    localCommentary1Count(item) {
      return this.localCommentary1CountFn(item);
    },
    localCommentary2Count(item) {
      return this.localCommentary2CountFn(item);
    },
    regionalCommentary1Count(item) {
      return this.regionalCommentary1CountFn(item);
    },
    regionalCommentary2Count(item) {
      return this.regionalCommentary2CountFn(item);
    },
    commentaryChart(comment, reason) {
      return this.commentaryChartFn(comment, reason);
    },
    isActualJVCommentaryValidForLocal(item) {
      return this.isActualJVCommentaryValidForLocalFn(item);
    },
    isActualJVCommentaryValidForRegional(item) {
      return this.isActualJVCommentaryValidForRegionalFn(item);
    },
    isForecastJVCommentaryValidForLocal(item) {
      return this.isForecastJVCommentaryValidForLocalFn(item);
    },
    isForecastJVCommentaryValidForRegional(item) {
      return this.isForecastJVCommentaryValidForRegionalFn(item);
    },
    paddingStyle(item) {
      return { paddingLeft: `${item.level * 10}px` };
    },
    rowStyle(item) {
      return {
        fontWeight: item.level === 0 ? 'bold' : 'normal',
        backgroundColor: item.level === 0 ? '#f5f5f5' : 'transparent',
      };
    },
    varianceClass(amount) {
      if (amount > 0) return 'success--text font-weight-bold';
      if (amount < 0) return 'error--text font-weight-bold';
      return '';
    },
    formatObjectEntries(obj) {
      if (!obj) return '';
      return Object.entries(obj)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
    },
  },
};
</script>
